import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Header from '../components/Header';
import Footer from '../components/Footer';
import AnimateReveal from '../components/AnimateReveal';
import { useAuth } from '../context/AuthContext';
import { Link } from 'react-router-dom';

import trial from "../../src/assets/images/trial-bg.png"


const Subscriptions = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const plans = [
    {
      id: '1month',
      name: '1 Mois',
      price: 1.99,
      description: 'Profitez d\'un accès immédiat au catalogue complet de films et séries en Full HD 1080p. Idéal pour découvrir le service sans engagement.',
      duration: '30 jours'
    },
    {
      id: '6months',
      name: '6 Mois',
      price: 11.99,
      description: 'Accédez au catalogue complet de films et séries en Full HD 1080p à un tarif avantageux. Le choix le plus populaire pour profiter du service sur la durée.',
      duration: '180 jours'
    },
    {
      id: '12months',
      name: '12 Mois',
      price: 23.99,
      description: 'Profitez du catalogue complet de films et séries en Full HD 1080p toute l\'année. L\'offre la plus avantageuse pour une expérience sans interruption.',
      duration: '365 jours'
    }
  ];

  const handleSelectPlan = (planId) => {
    if (!isAuthenticated) {
      navigate('/login');
      return;
    }
    setSelectedPlan(planId);
    setShowPaymentModal(true);
  };

  const handleCryptoPayment = async () => {
    setLoading(true);
    try {
      const res = await axios.post('/api/payments/oxapay/create', { plan: selectedPlan });
      window.location.href = res.data.paymentUrl;
    } catch (error) {
      console.error('Payment error:', error);
      const errorMessage = error.response?.data?.message || error.message || 'Payment initialization failed';
      alert(`Payment Error: ${errorMessage}`);
      setLoading(false);
    }
  };

  const handleCardPayment = () => {
    // Redirect to Telegram for card payment support
    window.open('https://t.me/H4_STREAM', '_blank');
    setShowPaymentModal(false);
  };

  return (
    <div className="min-h-screen bg-[#141414]">
      <Header />
      
      <div className="container mx-auto px-4 py-12">
        <AnimateReveal animation="fadeUp">
        <div className="text-center md:text-start mb-12">
          <h1 className="text-4xl font-bold text-white mb-4">Choisissez le plan qui vous convient</h1>
          <p className="text-center md:text-start text-gray-300 text-lg">
            Rejoignez H4KIG STREAM et choisissez parmi nos options d'abonnement flexibles adaptées à vos préférences de visionnage. Préparez-vous pour un divertissement sans fin !
          </p>
        </div>
        </AnimateReveal>

        {/* Plans */}
        <AnimateReveal animation="fadeUp" delay={50}>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {plans.map((plan) => (
            <div
              key={plan.id}
              className={`bg-[#262626] rounded-lg p-6 ${
                plan.id === '6months' ? 'ring-2 ring-white' : ''
              }`}
            >
              {plan.id === '6months' && (
                <div className="bg-white text-gray-900 text-xs font-bold px-2 py-1 rounded inline-block mb-4">
                  Populaire
                </div>
              )}
              <h3 className="text-2xl font-bold text-white mb-2">{plan.name}</h3>
              <p className="text-gray-400 mb-4">{plan.description}</p>
              <div className="text-4xl font-bold text-white mb-6">€{plan.price}</div>
              <button
                onClick={() => handleSelectPlan(plan.id)}
                className="w-full py-3 bg-[#FFFFFF] text-[#000000] rounded-lg hover:bg-gray-600 transition font-semibold"
              >
                Choisir ce plan
              </button>
            </div>
          ))}
        </div>
        </AnimateReveal>

        {/* Comparison Table */}
        <AnimateReveal animation="fadeUp" delay={100}>
        <div className="mb-12">
          <h2 className="text-4xl font-bold text-white text-center md:text-start mb-6">
            Comparez nos plans et trouvez celui qui vous convient
          </h2>
          <p className="text-gray-300 text-center md:text-start mb-8">
            H4KIG STREAM propose trois plans différents pour répondre à vos besoins. Comparez les fonctionnalités de chaque plan et choisissez celui qui vous convient.
          </p>

          {/* MOBILE: Cards */}
          <div className="grid grid-cols-1 gap-4 md:hidden">
            {[
              {
                title: "1 Mois",
                price: "€1.99",
                content: "Profitez d'un accès immédiat au catalogue complet de films et séries en Full HD 1080p. Idéal pour découvrir le service sans engagement.",
                popular: false,
              },
              {
                title: "6 Mois",
                price: "€11.99",
                content: "Accédez au catalogue complet de films et séries en Full HD 1080p à un tarif avantageux. Le choix le plus populaire pour profiter du service sur la durée.",
                popular: true,
              },
              {
                title: "12 Mois",
                price: "€23.99",
                content: "Profitez du catalogue complet de films et séries en Full HD 1080p toute l'année. L'offre la plus avantageuse pour une expérience sans interruption.",
                popular: false,
              },
            ].map((plan) => (
              <div
                key={plan.title}
                className="bg-[#0F0F0F] border border-[#262626] rounded-2xl p-5"
              >
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-white text-lg font-semibold">{plan.title}</h3>
                  {plan.popular && (
                    <span className="text-xs bg-white text-gray-900 px-2 py-1 rounded">
                      Populaire
                    </span>
                  )}
                </div>

                <div className="space-y-3">
                  <div className="flex items-start justify-between gap-4">
                    <span className="text-gray-400">Prix</span>
                    <span className="text-white font-medium">{plan.price}</span>
                  </div>

                  <div className="flex flex-col gap-2">
                    <span className="text-gray-400">Qualité vidéo</span>
                    <span className="text-white text-sm">Full HD 1080p</span>
                  </div>

                  <div className="flex flex-col gap-2">
                    <span className="text-gray-400">Contenu</span>
                    <span className="text-white text-sm">{plan.content}</span>
                  </div>

                  <div className="flex items-start justify-between gap-4">
                    <span className="text-gray-400">Annulation à tout moment</span>
                    <span className="text-white font-medium">Oui</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* DESKTOP: Table */}
          <div className="hidden md:block rounded-lg overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full min-w-[900px] border border-[#262626] rounded-xl">
                <thead>
                  <tr className="border-b border-[#262626] bg-[#0F0F0F]">
                    <th className="px-6 py-4 text-left text-white font-semibold">
                      Fonctionnalités
                    </th>
                    <th className="px-6 py-4 text-start text-white font-semibold">
                      1 Mois
                    </th>
                    <th className="px-6 py-4 text-start text-white font-semibold">
                      6 Mois
                      <span className="ml-2 text-xs bg-white text-gray-900 px-2 py-1 rounded">
                        Populaire
                      </span>
                    </th>
                    <th className="px-6 py-4 text-start text-white font-semibold">
                      12 Mois
                    </th>
                  </tr>
                </thead>

                <tbody className="bg-transparent">
                  <tr className="border-b border-[#262626]">
                    <td className="px-6 py-4 text-gray-300">Prix</td>
                    <td className="px-6 py-4 text-start text-white">€1.99</td>
                    <td className="px-6 py-4 text-start text-white">€11.99</td>
                    <td className="px-6 py-4 text-start text-white">€23.99</td>
                  </tr>

                  <tr className="border-b border-[#262626]">
                    <td className="px-6 py-4 text-gray-300">Qualité vidéo</td>
                    <td className="px-6 py-4 text-start text-white">Full HD 1080p</td>
                    <td className="px-6 py-4 text-start text-white">Full HD 1080p</td>
                    <td className="px-6 py-4 text-start text-white">Full HD 1080p</td>
                  </tr>

                  <tr className="border-b border-[#262626]">
                    <td className="px-6 py-4 text-gray-300">Écrans simultanés</td>
                    <td className="px-6 py-4 text-start text-white">1 écran</td>
                    <td className="px-6 py-4 text-start text-white">1 écran</td>
                    <td className="px-6 py-4 text-start text-white">1 écran</td>
                  </tr>

                  <tr className="border-b border-[#262626]">
                    <td className="px-6 py-4 text-gray-300">Contenu disponible</td>
                    <td className="px-6 py-4 text-start text-white">Catalogue complet</td>
                    <td className="px-6 py-4 text-start text-white">Catalogue complet</td>
                    <td className="px-6 py-4 text-start text-white">Catalogue complet</td>
                  </tr>

                  <tr className="border-b border-[#262626]">
                    <td className="px-6 py-4 text-gray-300">Publicités</td>
                    <td className="px-6 py-4 text-start text-white">Aucune</td>
                    <td className="px-6 py-4 text-start text-white">Aucune</td>
                    <td className="px-6 py-4 text-start text-white">Aucune</td>
                  </tr>

                  <tr className="border-b border-[#262626]">
                    <td className="px-6 py-4 text-gray-300">Appareils compatibles</td>
                    <td className="px-6 py-4 text-start text-white">TV, PC, Mobile, Mac</td>
                    <td className="px-6 py-4 text-start text-white">TV, PC, Mobile, Mac</td>
                    <td className="px-6 py-4 text-start text-white">TV, PC, Mobile, Mac</td>
                  </tr>

                  <tr className="border-b border-[#262626]">
                    <td className="px-6 py-4 text-gray-300">Mise à jour du catalogue</td>
                    <td className="px-6 py-4 text-start text-white">Régulière</td>
                    <td className="px-6 py-4 text-start text-white">Régulière</td>
                    <td className="px-6 py-4 text-start text-white">Régulière</td>
                  </tr>

                  <tr>
                    <td className="px-6 py-4 text-gray-300">Annulation à tout moment</td>
                    <td className="px-6 py-4 text-start text-white">Oui</td>
                    <td className="px-6 py-4 text-start text-white">Oui</td>
                    <td className="px-6 py-4 text-start text-white">Oui</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        </AnimateReveal>

      </div>
        <div className="container mx-auto px-4 mb-12">
          <div className="relative rounded-2xl overflow-hidden">
            <img
              src={trial}
              alt="Free trial background"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 " />
            <div className="relative z-10 p-8 md:p-20 ">
                <div className='flex items-center justify-between flex-col md:flex-row'>
                    <div className='flex flex-col items-start'>
                      <h2 className="text-center md:text-start text-3xl md:text-4xl font-semibold text-white mb-4">
                        Des milliers de films et séries, dès maintenant !
                      </h2>

                      <p className="text-gray-300 mb-6 text-center md:text-start">
                        Accès illimité au catalogue complet en Full HD 1080p, sans publicité.<br />
                        Compatible TV, PC, Mobile et Mac.
                      </p>                
                    </div>
                    <Link
                      to="/subscriptions"
                      className="inline-flex items-center justify-center px-6 py-3
                                bg-white text-gray-900 rounded-xl
                                hover:bg-gray-100 transition font-semibold"
                    >
                      Accès immédiat
                    </Link>                  
                </div>
            </div>

          </div>
        </div>      

      {/* Payment Method Modal */}
      {showPaymentModal && (
        <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 px-4">
          <div className="bg-[#1A1A1A] rounded-2xl p-8 max-w-md w-full border border-[#262626]">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-2xl font-bold text-white">Sélectionnez le mode de paiement</h2>
              <button
                onClick={() => setShowPaymentModal(false)}
                className="text-gray-400 hover:text-white transition"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <p className="text-gray-400 mb-6">Choisissez comment vous souhaitez effectuer votre paiement</p>

            <div className="space-y-4">
              {/* Crypto Payment Button */}
              <button
                onClick={handleCryptoPayment}
                disabled={loading}
                className="w-full p-4 bg-[#262626] hover:bg-[#2F2F2F] border border-[#3A3A3A] rounded-xl transition flex items-center justify-between group disabled:opacity-50"
              >
                <div className="flex items-center space-x-4">
                  <div className="bg-orange-500/20 p-3 rounded-lg">
                    <svg className="w-6 h-6 text-orange-500" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M23.638 14.904c-1.602 6.43-8.113 10.34-14.542 8.736C2.67 22.05-1.244 15.525.362 9.105 1.962 2.67 8.475-1.243 14.9.358c6.43 1.605 10.342 8.115 8.738 14.548v-.002zm-6.35-4.613c.24-1.59-.974-2.45-2.64-3.03l.54-2.153-1.315-.33-.525 2.107c-.345-.087-.705-.167-1.064-.25l.526-2.127-1.32-.33-.54 2.165c-.285-.067-.565-.132-.84-.2l-1.815-.45-.35 1.407s.975.225.955.236c.535.136.63.486.615.766l-1.477 5.92c-.075.166-.24.406-.614.314.015.02-.96-.24-.96-.24l-.66 1.51 1.71.426.93.242-.54 2.19 1.32.327.54-2.17c.36.1.705.19 1.05.273l-.51 2.154 1.32.33.545-2.19c2.24.427 3.93.257 4.64-1.774.57-1.637-.03-2.58-1.217-3.196.854-.193 1.5-.76 1.68-1.93h.01zm-3.01 4.22c-.404 1.64-3.157.75-4.05.53l.72-2.9c.896.23 3.757.67 3.33 2.37zm.41-4.24c-.37 1.49-2.662.735-3.405.55l.654-2.64c.744.18 3.137.524 2.75 2.084v.006z"/>
                    </svg>
                  </div>
                  <div className="text-left">
                    <h3 className="text-white font-semibold">Cryptomonnaie</h3>
                    <p className="text-sm text-gray-400">Payer avec Bitcoin, USDT, etc.</p>
                  </div>
                </div>
                <svg className="w-5 h-5 text-gray-400 group-hover:text-white transition" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </button>

              {/* Card Payment Button */}
              <button
                onClick={handleCardPayment}
                className="w-full p-4 bg-[#262626] hover:bg-[#2F2F2F] border border-[#3A3A3A] rounded-xl transition flex items-center justify-between group"
              >
                <div className="flex items-center space-x-4">
                  <div className="bg-blue-500/20 p-3 rounded-lg">
                    <svg className="w-6 h-6 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                    </svg>
                  </div>
                  <div className="text-left">
                    <h3 className="text-white font-semibold">Paiement par carte</h3>
                    <p className="text-sm text-gray-400">Contactez le support pour le paiement par carte</p>
                  </div>
                </div>
                <svg className="w-5 h-5 text-gray-400 group-hover:text-white transition" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default Subscriptions;
